import axios from '../../../api/axios.js'
import axios2 from '../../../api/axios2.js'
import { buryPointUrl, provideUrl, b2bUrls } from '../../../api/config.js'
// 首页搜索
export const getSearchInfo = params => axios2(b2bUrls + '/product/open-api/homepage/search', { params }, 'get')
// 热门搜索
export const hotSearch = params => {
    return axios.get(buryPointUrl + '/ets/api/b2b/homepage/hot-words', { params })
}
// 会员体系新接口开始
// 发送验证码
export const getSendSms = params => {
    return axios.get('uaa/openapi/user/send-sms', { params })
}
// 获取我的推荐列表
export const getMyMember = params => {
    return axios.get(`merchant/api/members/recommended/app/${params.userId}`, { params })
}
// 用户注册
export const getRegister = params => {
    return axios.post('uaa/openapi/user/register', params)
}
// 获取用户信息
export const getUserInfo = params => {
    return axios.get('uaa/api/user/user-info/0', { params })
}
// 获取当前企业是否认证
export const isApprove = params => {
    return axios.get('merchant/api/company/app/authentication', { params })
}
// 修改头像
export const updateAvatar = params => {
    return axios.put('uaa/api/user/update-avatar', params)
}
// 更换手机号
export const updateMobile = params => {
    return axios.put('uaa/api/user/update-mobile', params)
}
// 修改姓名
export const updateName = params => {
    return axios.put('uaa/api/user/update-name', params)
}
// 修改密码
export const updatePassWord = params => {
    return axios.put('uaa/api/user/update-password', params)
}
// 创建企业
export const createCompany = params => {
    return axios.post('merchant/api/company/app', params)
}
// 修改企业
export const editCompany = params => {
    return axios.put('merchant/api/company/app', params)
}
// 切换企业
export const switchCompany = params => {
    return axios.post('uaa/api/user-company/app/user/switch-company', params)
}
// 获取最新token
export const getToken = params => {
    return axios.post('oauth/refresh-token', params)
}
// 退出企业
export const outCompany = params => {
    return axios.post('uaa/api/user-company/user/member/sign-out', params)
}
// 企业列表
export const companyList = params => {
    return axios.get('merchant/api/company/app', { params })
}
// 添加所属商家
export const addCompany = params => {
    return axios.put('merchant/api/company/app/add-merchant', params)
}
// 员工列表
export const staffList = params => {
    return axios.get(`uaa/api/user/staff-list/${params.companyCode}`, { params })
}
// 移除员工
export const delStaff = params => {
    return axios.delete(`uaa/api/user/staff-delete`, { params })
}
// 结束

// 获取最新APK
export const getNewApk = params => {
    return axios.get(buryPointUrl + '/ims/app-versions/latest', { params })
}
// 获取商家类型（这个不需要了）
export const getType = params => {
    return axios.get(`merchant/api/merchant-type/${params.merchantCode}`, {})
}
// 获取商品的最大返利
export const getRebate = params => {
    return axios.get(`product/api/sku/${params.skuId}/rebate/max`, { params })
}
// 获取商品状态
export const getStatus = params => {
    return axios.get(`/product/api/market/app/sku-sell`, { params })
}

// 加入购物车
export const addShop = params => {
    return axios.post('order/api/shopping-carts', params)
}
// 修改购物车
export const editShop = params => {
    return axios.put(`order/api/shopping-carts/${params.id}`, params)
}
// 订单确认提交
export const submitOrder = params => axios2(b2bUrls + '/order/api/app/orders/submit', params, 'post')

// 最新修改
// 活动埋点
export const activityInfo = params => {
    return axios.post(buryPointUrl + '/ets/api/b2b/activity/save', params)
}
// 原来的埋点
export const buryPoint = params => {
    return axios.post(buryPointUrl + '/ets/api/event-tracks', params)
}
// 游客埋点
export const buryvisitorPoint = params => {
    return axios.post(buryPointUrl + '/ets/visitor/event-tracks', params)
}
// 获取会员信息
export const getMember = params => {
    return axios.get(`merchant/api/members/${params.memberCode}`, {})
}
// 获取购物车
export const getcartList = params => {
    return axios.get('order/api/shopping-carts', { params })
}
// 购物车数量
export const cartNum = params => {
    return axios.get('order/api/shopping-carts/count', { params })
}
// 批量删除购物车的商品
export const delCart = params => {
    return axios.put('order/api/shopping-carts/batch-deletion', params)
}
// 获取商品加入购物车数量
export const getCartNum = params => {
    return axios.get('order/api/shopping-carts/product-existing-quantity', { params })
}
// 获取首页楼层信息
export const floorsInfo = params => {
    return axios.get('merchant/api/shops/app/index-page', { params })
}
// 获取首页专栏列表
export const getColumn = params => {
    return axios.get('merchant/api/special-columns', { params })
}
// 获取楼层商品
export const getFloorProduct = params => {
    return axios.get('/merchant/api/floors/product/member', { params })
}
// 获取首页banner和会员店信息
export const bannerInfo = params => {
    return axios.get('merchant/api/shops/app/banner-introduction', { params })
}
// 省市区新接口
export const getArea = params => {
    return axios.get(provideUrl + '/common/region/provinces/nesting', {})
}
// 获取企业最新的经营区域地址
export const getBusinessArea = params => {
    return axios.get(`merchant/api/company/${params.companyCode}/area`, {})
}
// 查看该用户是否开启账期
export const getIsPay = params => {
    return axios.get(`merchant/api/member-payment-methods/paymethod/${params.memberCode}`, {})
}
// 查看收藏夹数量（暂时未用到）
export const getCollectNum = params => {
    return axios.get('order/api/favorites/count', { params })
}
// 各状态订单数量
export const getOrderNum = params => {
    return axios.get('order/api/app/orders/quantity-statistics', { params })
}
// 获取账期额度
export const getPayment = params => {
    return axios.get('payment/api/terms/personal-details', { params })
}
// 查询浮层
export const getSuper = params => {
    return axios.get(`/merchant/api/supernatants/${params.merchantCode}`, {})
}
// 查询首页商品一级类目列表/类目列表
export function findIndexCategoryList (params) {
    return axios.get(`product/open-api/exist-spu/category`, { params })
}
// 根据平台公司code获取首页内容
export const getHome2 = params => {
    return axios.get('merchant/api/shops/preview/index', { params })
}
// 获取我的专属服务
export const getMyServer = params => {
    return axios.get('uaa/api/user-members/exclusive-service', { params })
}
// 获取品牌列表(商品改版成功后删除)
// export const getbrandList = (params) => {
//     return axios.get('product/api/brands/app', { params })
// }
export const getbrandList = params => {
    return axios.get('product/open-api/exist-spu/brand', { params })
}
// 获取按字母分组
export const getbrandSpell = params => {
    return axios.get('product/open-api/brand/first-spell', { params })
}
// 开户
export const postOpen = params => {
    return axios.post('/payment/api/accounts/open-account', params)
}

// 企业银行开户信息
export const getOpenAccountInfo = params => {
    return axios.get(`/payment/api/accounts/open-account-info/${params.companyCode}`)
}

// 银行转账升级
export const getUpgrade = params => {
    return axios.post('/payment/api/bankcard/upgrade/individual', params)
}

// 个人绑卡提交
export const postIndividual = params => {
    return axios.post('/payment/api/bankcard/bind/individual', params)
}

// 个人绑卡确认
export const postIndConfirm = params => {
    return axios.post('/payment/api/bankcard/bind/individual/confirm', params)
}

// 企业绑卡提交
export const postCorporation = params => {
    return axios.post('/payment/api/bankcard/bind/corporation', params)
}

// 企业绑卡确认
export const postCorConfirm = params => {
    return axios.post('/payment/api/bankcard/bind/corporation/confirm', params)
}

// 发短信验证码
export const sendSms = params => {
    return axios.post('/payment/api/bankcard/send-sms', params)
}

// 根据卡号获取银行卡
export const getBank = params => {
    return axios.get(`/payment/api/bank/${params}`)
}

// 银行卡模糊查询
export const getSearchBankList = params => {
    return axios.get('/payment/api/bank/list/fuzzy-by-name', { params })
}

// 我的所有银行卡
export const getMyBank = params => {
    return axios.get('/payment/api/bankcard', { params })
}

// 我的钱包用户信息
export const getAssetsUserInfo = params => {
    return axios.get('/payment/api/accounts/user-info', { params })
}

// app-用户账单信息
export const getAppbillInfo = params => {
    return axios.get('/payment/api/accounts/bill-info', { params })
}

// 提现银行卡列表
export const getBankcardWithdrawList = params => {
    return axios.get(`payment/api/bankcard/withdraw/list`, { params })
}

// 提现银行卡
export const getBankcardWithdraw = params => {
    return axios.get(`payment/api/bankcard/withdraw`, { params })
}

// 刷新绑卡状态
export const postRfStatus = params => {
    return axios.get('/payment/api/bankcard/bind/refresh-status', { params })
}

// 银行卡删除接口
export const putBank = params => {
    return axios.put('/payment/api/bankcard', params)
}

// 支付收银台信息
export const getCashierdesk = params => {
    return axios.get('/payment/api/bankcard/cashier-desk', { params })
}

// 支付发短信验证码
export const postAppPaymentsSendSms = params => {
    return axios.post(`/payment/api/app/payments/send-sms?bankCardId=${params}`)
}

// 支付验证短信验证码
export const postAppPaymentsVerifySms = params => {
    return axios.post(`/payment/api/app/payments/verify-sms`, params)
}

// 提现发短信验证码
export const postCashOutSendSms = params => {
    return axios.post(`/payment/api/accounts/withdraw/send-sms`, params)
}

// 提现验证短信验证码
export const postCashOutVerifySms = params => {
    return axios.post(`/payment/api/accounts/withdraw/verify-sms`, params)
}

// APP端支付接口
export const postAppPaymentsPay = params => {
    return axios.post('/payment/api/app/payments/pay', params)
}

// APP端提现接口
export const postWithdraw = params => {
    return axios.post('/payment/api/accounts/withdraw', params)
}

// APP端获取手续费率接口
export const getFeeRate = params => {
    return axios.get('/payment/api/boss/service-fee/withdraw-rate', {})
}

// APP端服务费计算
export const getFeeCalculation = params => {
    return axios.post('/payment/api/boss/service-fee/calculation', params)
}

// 支付状态查询接口
export const getPayStatus = params => {
    return axios.get('/payment/api/app/payments/status', { params })
}

// 企业详情
export const getCompanyDetail = params => {
    return axios.get('/merchant/api/company/app/detail', { params })
}

// OCR识别营业执照
export const getOcrFromBL = params => {
    return axios.post(`/merchant/api/aliyun/ocr/business-license?image=${params.image}`, params)
}
// OCR识别身份证
export const getOcrFromID = params => {
    return axios.post(`/merchant/api/aliyun/ocr/id-card-portrait?image=${params.image}`, params)
}
// OCR识别开户核准号
export const getOcrFromOpen = params => {
    return axios.post(`/merchant/api/aliyun/ocr/open-license-and-basic-deposit-account?image=${params.image}`, params)
}

// 线下转账白名单-列表
export const getOfflinePaymentWhiteList = params => {
    return axios.get(`/payment/api/accounts/app/offline-payment-white-list/${params.companyCode}`, {})
}

// 线下转账白名单-新增
export const postOfflinePaymentWhiteList = params => {
    return axios.post('/payment/api/accounts/app/offline-payment-white-list', params)
}
// 获取战区商品列表
export const getMemberList = params => {
    return axios.get('/merchant/api/wxmp/company/limit-merchant', { params })
}
// 生产商品分享图片
export const getGoodPic = params => {
    return axios.get('/product/app/share-image', { params })
}
// 询价列表
export const getEnquiryList = params => {
    return axios.get('/inquiry/app/inquiries/page', { params })
}
// 询价详情
export const getEnquiryDetail = params => {
    return axios.get(`/inquiry/app/inquiries/${params.id}/detail`, { params })
}
// 询价品牌列表
export const getBrand = params => {
    return axios.get(`/product/api/brands/first-spell`, { params })
}
// 提交询价单
export const getSubmitEnquiry = params => axios2(b2bUrls + '/inquiry/app/inquiries', params, 'post')
// 询价单已选商品
export const getEnquiryGood = params => {
    return axios.get(`/inquiry/app/inquiries/${params.id}/skus`, { params })
}
// 询价商品去结算校验
export const getCheckGood = params => {
    return axios.get(`/inquiry/app/inquiries/go-pay-check/${params.inquiryId}`, { params })
}
// 获取注册/分享二维码
export const getShareCode = params => {
    return axios.get(`/uaa/api/user-profiles/${params.userId}`, {})
}
// 获取邀请码
export const getInvitationCode = params => {
    return axios.get(`/uaa/api/member-users/invitation-code/${params.userId}`, {})
}
// 获取会员权益列表
export const getMemberEquityList = params => {
    return axios.get(`/merchant/api/member/rights/app`, { params })
}
export const saveQuestionnaire = params => {
    return axios.post('merchant/api/questionnaire', params)
}
// 获取平台权益的json数据
export const getJsonData = () => {
    return axios.get('https://hosjoy-oss-test.oss-cn-hangzhou.aliyuncs.com/json/test.json?v=' + new Date().getTime())
}
// 活动钱包屏蔽
export const activityShield = params => {
    return axios.get(`merchant/api/members/${params.memberCode}/activity-wallet`, { params })
}
// 查看店铺信息
export const shopInfo = params => {
    return axios.get(`merchant/api/merchants/${params.merchantCode}/shop`)
}
// 优选商品信息
export const preferablyInfo = params => {
    return axios.get(`merchant/api/optimization-product/page`, { params })
}
// 查看资料库信息
export const lookBankInfo = params => {
    return axios.get(`merchant/api/material-library/${params.materialLibraryId}`, { params })
}
// 资料库列表
export const dataBankList = params => {
    return axios.get(`merchant/api/material/page`, { params })
}
// 我的页面应返明细和满返余额
export const myRebate = params => {
    return axios.get('ops/app/rebate/my-rebate', { params })
}
// 应返明细页(总差距和总应返)
export const shouldRebate = params => {
    return axios.get('ops/app/rebate/should-rebate', { params })
}
// 应返明细页
export const shouldRebatePage = params => {
    return axios.get('ops/app/rebate/should-rebate-page', { params })
}
// 满返余额
export const myRebateBalance = params => {
    return axios.get('ops/app/rebate/my-rebate-balance', { params })
}
// 满返账单
export const merchantFlowpage = params => {
    return axios.get('ops/app/rebate/flow/merchant-flow-page', { params })
}
